import { UseGetProjectByIdReturn } from '@/lib/useQuery/project/useGetProjectById';
import * as Sentry from '@sentry/react';

export function setProjectContext(project: UseGetProjectByIdReturn) {
    const scope = Sentry.getCurrentScope();
    if (project) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { project_members, crm_project, organisation, ...projectData } = project;
        scope.setTag("projectId", project.id);
        scope.setContext("project", { ...projectData });
        scope.setContext("projectMembers", Object.fromEntries(
            project_members.map((member) => [member.id, member])
        ));
        const { crm, selected_configuration: project_selected_configuration, ...crm_project_data } = crm_project || {};
        scope.setContext("crmProject", { ...crm_project_data || {} });
        scope.setContext("crmProjectSelectedConfiguration", {
            selected_configuration: JSON.stringify(project_selected_configuration || {})
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { selected_configuration: crm_selected_configuration, configuration, configuration_data, crm_config, ...crm_data } = crm || {};
        scope.setContext("crm", { ...crm_data || {} });
        scope.setContext("crmSelectedConfiguration", {
            selected_configuration: JSON.stringify(crm_selected_configuration || {})
        });
        scope.setContext("crmConfiguration", { configuration: JSON.stringify(configuration || {}) });
        scope.setContext("crmConfigurationData", { configuration_data: JSON.stringify(configuration_data || {}) });
    } else {
        console.log("Clear project scope")
        scope.clear();
    }
}